var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 4.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 4.5,
    stroke: "#202020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.136 21.7509C65.784 21.7509 63.867 23.5399 63.867 26.0039C63.867 28.4529 65.784 30.2569 68.136 30.2569C70.489 30.2569 72.406 28.4529 72.406 26.0039C72.405 23.5399 70.488 21.7509 68.136 21.7509ZM68.136 28.5829C66.847 28.5829 65.736 27.5199 65.736 26.0049C65.736 24.4739 66.848 23.4269 68.136 23.4269C69.425 23.4269 70.536 24.4739 70.536 26.0049C70.536 27.5189 69.425 28.5829 68.136 28.5829ZM58.822 21.7509C56.47 21.7509 54.553 23.5399 54.553 26.0039C54.553 28.4529 56.47 30.2569 58.822 30.2569C61.175 30.2569 63.092 28.4529 63.092 26.0039C63.092 23.5399 61.175 21.7509 58.822 21.7509ZM58.822 28.5829C57.533 28.5829 56.422 27.5199 56.422 26.0049C56.422 24.4739 57.534 23.4269 58.822 23.4269C60.111 23.4269 61.222 24.4739 61.222 26.0049C61.223 27.5189 60.111 28.5829 58.822 28.5829ZM47.744 23.0569V24.8609H52.062C51.933 25.8759 51.595 26.6169 51.079 27.1319C50.451 27.7599 49.468 28.4529 47.744 28.4529C45.086 28.4529 43.008 26.3099 43.008 23.6519C43.008 20.9939 45.086 18.8509 47.744 18.8509C49.178 18.8509 50.225 19.4149 50.998 20.1399L52.271 18.8669C51.191 17.8359 49.758 17.0469 47.744 17.0469C44.103 17.0469 41.042 20.0109 41.042 23.6519C41.042 27.2929 44.103 30.2569 47.744 30.2569C49.709 30.2569 51.192 29.6119 52.351 28.4039C53.543 27.2119 53.914 25.5359 53.914 24.1829C53.914 23.7649 53.882 23.3779 53.817 23.0559H47.744V23.0569ZM93.052 24.4579C92.698 23.5079 91.618 21.7509 89.411 21.7509C87.22 21.7509 85.399 23.4749 85.399 26.0039C85.399 28.3879 87.204 30.2569 89.62 30.2569C91.569 30.2569 92.697 29.0649 93.165 28.3719L91.715 27.4049C91.232 28.1139 90.571 28.5809 89.62 28.5809C88.67 28.5809 87.993 28.1459 87.558 27.2919L93.245 24.9399L93.052 24.4579ZM87.252 25.8759C87.204 24.2319 88.525 23.3949 89.476 23.3949C90.217 23.3949 90.845 23.7659 91.055 24.2969L87.252 25.8759ZM82.629 29.9999H84.497V17.4989H82.629V29.9999ZM79.567 22.7019H79.503C79.084 22.2019 78.278 21.7509 77.264 21.7509C75.137 21.7509 73.188 23.6199 73.188 26.0209C73.188 28.4049 75.137 30.2579 77.264 30.2579C78.279 30.2579 79.084 29.8069 79.503 29.2919H79.567V29.9039C79.567 31.5309 78.697 32.4009 77.296 32.4009C76.152 32.4009 75.443 31.5799 75.153 30.8869L73.526 31.5639C73.993 32.6909 75.233 34.0769 77.296 34.0769C79.487 34.0769 81.34 32.7879 81.34 29.6459V22.0099H79.568V22.7019H79.567ZM77.425 28.5829C76.136 28.5829 75.057 27.5029 75.057 26.0209C75.057 24.5219 76.136 23.4269 77.425 23.4269C78.697 23.4269 79.696 24.5219 79.696 26.0209C79.696 27.5029 78.697 28.5829 77.425 28.5829ZM101.806 17.4989H97.335V29.9999H99.2V25.2639H101.805C103.873 25.2639 105.907 23.7669 105.907 21.3819C105.907 18.9969 103.874 17.4989 101.806 17.4989ZM101.854 23.5239H99.2V19.2389H101.854C103.249 19.2389 104.041 20.3939 104.041 21.3819C104.041 22.3499 103.249 23.5239 101.854 23.5239ZM113.386 21.7289C112.035 21.7289 110.636 22.3239 110.057 23.6429L111.713 24.3339C112.067 23.6429 112.727 23.4169 113.418 23.4169C114.383 23.4169 115.364 23.9959 115.38 25.0249V25.1539C115.042 24.9609 114.318 24.6719 113.434 24.6719C111.649 24.6719 109.831 25.6529 109.831 27.4859C109.831 29.1589 111.295 30.2359 112.935 30.2359C114.189 30.2359 114.881 29.6729 115.315 29.0129H115.379V29.9779H117.181V25.1849C117.182 22.9669 115.524 21.7289 113.386 21.7289ZM113.16 28.5799C112.55 28.5799 111.697 28.2739 111.697 27.5179C111.697 26.5529 112.759 26.1829 113.676 26.1829C114.495 26.1829 114.882 26.3599 115.38 26.6009C115.235 27.7599 114.238 28.5799 113.16 28.5799ZM123.743 22.0019L121.604 27.4219H121.54L119.32 22.0019H117.31L120.639 29.5769L118.741 33.7909H120.687L125.818 22.0019H123.743ZM106.937 29.9999H108.802V17.4989H106.937V29.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4176 10.2432C47.4176 11.0812 47.1696 11.7482 46.6726 12.2462C46.1086 12.8382 45.3726 13.1342 44.4686 13.1342C43.6026 13.1342 42.8656 12.8342 42.2606 12.2342C41.6546 11.6332 41.3516 10.8892 41.3516 10.0012C41.3516 9.11219 41.6546 8.36819 42.2606 7.76819C42.8656 7.16719 43.6026 6.86719 44.4686 6.86719C44.8986 6.86719 45.3096 6.95119 45.6996 7.11819C46.0906 7.28619 46.4036 7.50919 46.6376 7.78819L46.1106 8.31619C45.7136 7.84119 45.1666 7.60419 44.4676 7.60419C43.8356 7.60419 43.2896 7.82619 42.8286 8.27019C42.3676 8.71419 42.1376 9.29119 42.1376 10.0002C42.1376 10.7092 42.3676 11.2862 42.8286 11.7302C43.2896 12.1742 43.8356 12.3962 44.4676 12.3962C45.1376 12.3962 45.6966 12.1732 46.1436 11.7262C46.4336 11.4352 46.6016 11.0302 46.6466 10.5112H44.4676V9.79019H47.3746C47.4046 9.94719 47.4176 10.0982 47.4176 10.2432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0277 7.73724H49.2957V9.63924H51.7597V10.3602H49.2957V12.2622H52.0277V13.0002H48.5247V7.00024H52.0277V7.73724Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2785 13.0002H54.5075V7.73724H52.8315V7.00024H56.9545V7.73724H55.2785V13.0002Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9375 13.0002V7.00024H60.7085V13.0002H59.9375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1277 13.0002H63.3567V7.73724H61.6807V7.00024H65.8037V7.73724H64.1277V13.0002Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6084 12.2252C73.0184 12.8312 72.2854 13.1342 71.4084 13.1342C70.5314 13.1342 69.7984 12.8312 69.2094 12.2252C68.6194 11.6192 68.3254 10.8772 68.3254 10.0002C68.3254 9.12323 68.6194 8.38123 69.2094 7.77523C69.7984 7.16923 70.5314 6.86523 71.4084 6.86523C72.2804 6.86523 73.0124 7.17023 73.6044 7.77923C74.1964 8.38823 74.4924 9.12823 74.4924 10.0002C74.4924 10.8772 74.1974 11.6192 73.6084 12.2252ZM69.7784 11.7222C70.2224 12.1722 70.7654 12.3962 71.4084 12.3962C72.0514 12.3962 72.5954 12.1712 73.0384 11.7222C73.4824 11.2722 73.7054 10.6982 73.7054 10.0002C73.7054 9.30223 73.4824 8.72823 73.0384 8.27823C72.5954 7.82823 72.0514 7.60423 71.4084 7.60423C70.7654 7.60423 70.2224 7.82923 69.7784 8.27823C69.3354 8.72823 69.1124 9.30223 69.1124 10.0002C69.1124 10.6982 69.3354 11.2722 69.7784 11.7222Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5745 13.0002V7.00024H76.5125L79.4285 11.6672H79.4615L79.4285 10.5112V7.00024H80.1995V13.0002H79.3945L76.3435 8.10625H76.3105L76.3435 9.26224V13.0002H75.5745Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4176 10.2432C47.4176 11.0812 47.1696 11.7482 46.6726 12.2462C46.1086 12.8382 45.3726 13.1342 44.4686 13.1342C43.6026 13.1342 42.8656 12.8342 42.2606 12.2342C41.6546 11.6332 41.3516 10.8892 41.3516 10.0012C41.3516 9.11219 41.6546 8.36819 42.2606 7.76819C42.8656 7.16719 43.6026 6.86719 44.4686 6.86719C44.8986 6.86719 45.3096 6.95119 45.6996 7.11819C46.0906 7.28619 46.4036 7.50919 46.6376 7.78819L46.1106 8.31619C45.7136 7.84119 45.1666 7.60419 44.4676 7.60419C43.8356 7.60419 43.2896 7.82619 42.8286 8.27019C42.3676 8.71419 42.1376 9.29119 42.1376 10.0002C42.1376 10.7092 42.3676 11.2862 42.8286 11.7302C43.2896 12.1742 43.8356 12.3962 44.4676 12.3962C45.1376 12.3962 45.6966 12.1732 46.1436 11.7262C46.4336 11.4352 46.6016 11.0302 46.6466 10.5112H44.4676V9.79019H47.3746C47.4046 9.94719 47.4176 10.0982 47.4176 10.2432Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0277 7.73724H49.2957V9.63924H51.7597V10.3602H49.2957V12.2622H52.0277V13.0002H48.5247V7.00024H52.0277V7.73724Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2785 13.0002H54.5075V7.73724H52.8315V7.00024H56.9545V7.73724H55.2785V13.0002Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9375 13.0002V7.00024H60.7085V13.0002H59.9375Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1277 13.0002H63.3567V7.73724H61.6807V7.00024H65.8037V7.73724H64.1277V13.0002Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6084 12.2252C73.0184 12.8312 72.2854 13.1342 71.4084 13.1342C70.5314 13.1342 69.7984 12.8312 69.2094 12.2252C68.6194 11.6192 68.3254 10.8772 68.3254 10.0002C68.3254 9.12323 68.6194 8.38123 69.2094 7.77523C69.7984 7.16923 70.5314 6.86523 71.4084 6.86523C72.2804 6.86523 73.0124 7.17023 73.6044 7.77923C74.1964 8.38823 74.4924 9.12823 74.4924 10.0002C74.4924 10.8772 74.1974 11.6192 73.6084 12.2252ZM69.7784 11.7222C70.2224 12.1722 70.7654 12.3962 71.4084 12.3962C72.0514 12.3962 72.5954 12.1712 73.0384 11.7222C73.4824 11.2722 73.7054 10.6982 73.7054 10.0002C73.7054 9.30223 73.4824 8.72823 73.0384 8.27823C72.5954 7.82823 72.0514 7.60423 71.4084 7.60423C70.7654 7.60423 70.2224 7.82923 69.7784 8.27823C69.3354 8.72823 69.1124 9.30223 69.1124 10.0002C69.1124 10.6982 69.3354 11.2722 69.7784 11.7222Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5745 13.0002V7.00024H76.5125L79.4285 11.6672H79.4615L79.4285 10.5112V7.00024H80.1995V13.0002H79.3945L76.3435 8.10625H76.3105L76.3435 9.26224V13.0002H75.5745Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_25918_128633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4357 7.53833C10.1447 7.84633 9.97266 8.32433 9.97266 8.94333V31.0593C9.97266 31.6793 10.1447 32.1563 10.4357 32.4643L10.5097 32.5363L22.8987 20.1473V20.0013V19.8553L10.5097 7.46533L10.4357 7.53833Z",
    fill: "url(#paint0_linear_25918_128633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0274 24.2781L22.8984 20.1471V20.0011V19.8551L27.0284 15.7251L27.1214 15.7781L32.0144 18.5581C33.4114 19.3521 33.4114 20.6511 32.0144 21.4461L27.1214 24.2261L27.0274 24.2781Z",
    fill: "url(#paint1_linear_25918_128633)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_25918_128633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1215 24.225L22.8975 20.001L10.4355 32.464C10.8955 32.952 11.6565 33.012 12.5135 32.526L27.1215 24.225Z",
    fill: "url(#paint2_linear_25918_128633)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1215 15.7772L12.5135 7.47719C11.6565 6.99019 10.8955 7.05119 10.4355 7.53919L22.8985 20.0022L27.1215 15.7772Z",
    fill: "url(#paint3_linear_25918_128633)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_25918_128633",
    x: 9.97266,
    y: 7.14111,
    width: 23.0898,
    height: 25.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_25918_128633"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_25918_128633",
    result: "effect2_innerShadow_25918_128633"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_25918_128633",
    x: 10.4355,
    y: 20.001,
    width: 16.6855,
    height: 12.8608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_25918_128633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25918_128633",
    x1: 21.8005,
    y1: 8.70933,
    x2: 5.01846,
    y2: 25.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25918_128633",
    x1: 33.8329,
    y1: 20.0011,
    x2: 9.63704,
    y2: 20.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25918_128633",
    x1: 24.8276,
    y1: 22.2949,
    x2: 2.06915,
    y2: 45.0534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25918_128633",
    x1: 7.29695,
    y1: 0.176989,
    x2: 17.4592,
    y2: 10.3393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.05030f45eba9130bec9a5892c7b67749.svg";
export { ForwardRef as ReactComponent };